var map = {
	"./wine-placeholder-blank.png": "e62e",
	"./wine-placeholder-fizzy.png": "b029",
	"./wine-placeholder-red.png": "9030",
	"./wine-placeholder-rose.png": "4013",
	"./wine-placeholder-white.png": "ae84",
	"./wine-placeholder-yellow.png": "dd65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f59";